import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "../src/assets/locales/en/translation.json";
import translationAR from "../src/assets/locales/ar/translation.json";

const getSavedLanguage = () => {
  if (typeof window !== "undefined" && window.localStorage) {
    const saved = localStorage.getItem("lang");
    if (saved === "Arabic" || saved === "ar") return "ar";
  }
  return "en";
};

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: translationEN },
    ar: { translation: translationAR },
  },
  lng: getSavedLanguage(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});
